export default __webpack_public_path__ + "static/media/logo.641b5d47.png";